import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { IonContent, IonFooter, IonHeader, IonModal } from '@ionic/react'
import i18n from 'i18next'
import { Icon } from '@cps'
import { storeMobx } from 'restaurant'
import { format } from '@dt/fe-utils'
import CashierController from '@ctrls/cashierController'
import './index.scss'

interface IProps extends TConfirmModalProps {
  title?: string;
  confirmText?: string;
}
interface IState {
  formatSaleTimes: string[];
}
const StoreStatusConfirmModal: FC<IProps> = (props) => {
  const history = CashierController.history()
  const initialState: IState = {
    formatSaleTimes: [],
  }
  const { info: store } = storeMobx
  const { saleTime = [] } = store
  const [formatSaleTimes, setFormatSaleTimes] = useState(
    initialState.formatSaleTimes
  )
  const handleToStore = () => {
    props.reject()
    history.replace('/store')
  }
  useEffect(() => {
    setFormatSaleTimes(format.toSaleTime(saleTime, bo === 'cn' ? '24' : '12'))
  }, [saleTime])

  return (
    <IonModal isOpen cssClass='store-status-confirm-modal'>
      <IonHeader>
        <Icon name='close' onClick={() => props.reject()}></Icon>
      </IonHeader>
      <IonContent scrollY={false}>
        <div className='sale-time-info-wrapper'>
          <Icon name='mendian' />
          <h3>{props.title}</h3>
          <span className='sale-time-info'>
            {i18n.t('store.thisStoreSaleTime')}：
          </span>
          <ul className='sale-time-list'>
            {formatSaleTimes.map((timeStr, index) => {
              return (
                <li className='sale-time-info' key={index}>
                  {timeStr}
                </li>
              )
            })}
          </ul>
          <span className='sale-time-info'>{i18n.t('store.welcome')}</span>
        </div>
        <div className='button-footer-wrapper'>
          <button type='button' onClick={() => props.reject()}>
            {props.confirmText}
          </button>
          {
            storeMobx.viewStoreList?.length > 1 ? (
              <button className='btn-link' type='button' onClick={handleToStore}>
                {i18n.t('store.toOtherStore')}
              </button>
            ) : null
          }
        </div>
      </IonContent>
    </IonModal>
  )
}

export default observer(StoreStatusConfirmModal)
